import React from "react";
import SubHeader from "../../components/SubHeader";
import InputField from "../../components/InputField";
import RadioButtonField from "../../components/RadioButtonField";
import DropDown from "../../components/DropDown";
import { default as ReactSelect } from "react-select";
import CreatableSelect from "react-select/creatable";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { useEffect, useState } from "react";
import axiosInstance from "../../axiosHttp";
import Select from "react-select";

import defaultValues from "../../constant/defaultValues";

import { capitalize, includes, isEmpty, map, size, trim } from "lodash";

import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

import {
  ClassicEditor,
  Bold,
  Essentials,
  Italic,
  Mention,
  Paragraph,
  Undo,
  TodoList,
  List,
  Font,
  Alignment,
  Link,
  AutoLink,
} from "ckeditor5";
import ButtonAdd from "../../components/ButtonAdd";
import ButtonAdminpanel from "../../components/ButtonAdminpanel";
import Choosefile from "../../components/Choosefile";
import {
  setAuthHeaders,
  showErrorMessage,
  showSuccessMessage,
} from "../../utils/common";

import API_URL from "../../constant/api.config";
import { countryList } from "../../actions/countryAction";
import { cityMemberList } from "../../actions/cityAction";
import { citySearchMemberList } from "../../actions/citySearchAction";
import { hideLoading, showLoading } from "../../actions/loaderAction";
import { connect } from "react-redux";
import {
  getHSCodeList,
  getHSCodeSearchList,
  getServiceByIndustry,
  searchPortList,
} from "../../actions/defaultDataAction";
import { getSubscriptionPlanList } from "../../actions/subscriptionPlanAction";
import axios from "axios";
import { json, useNavigate } from "react-router-dom";
import errorMessages from "../../constant/errorMessages";
import regExp from "../../constant/regExpressions";
import ROUTES from "../../config/routePath";
import { ToastContainer } from "react-toastify";
import { getParentServiceAction } from "../../actions/updateProfileAction";
import roles from "@/constant/roles.config";
import { useAuth } from "@/AuthProvider";
import { privateRoutePaths } from "@/routes/private.route.config";

function MemberDetailsForm(props) {

  const { user, isEndUser, isViewer, isPreKYCUser, isDemoUser } = useAuth();

  const { SOCIAL_MEDIA_OPTIONS, EMAIL_FIELD_MAX_LENGTH } = defaultValues;

  const [file, setFile] = useState({});
  const [errors, setErrors] = useState({});

  const [videosection, setvideosecion] = useState([
    {
      video_link: "",
    }
  ]);

  const [SocialMedia, setSocialMedia] = useState([
    { Link: "", social_media_option: "" }
  ]);

  var [isButtonDisabled, setisButtonDisabled] = useState(false);

  const [formData, setFormData] = useState({
    company_name: "",
    salutation: "Mr",
    first_name: "",
    last_name: "",
    email: "",
    country: "",
    city: "",
    hs_code: "",
    target_country: "",
    website: "",
    company_size: "",
    established_year: "",
    plan: "",
    trade_mode: "",
    company_industry: "",
    company_services: "",
    trade_mode_type: "BUYER",
    other_industry: "",
    data_source: "",
    address_country: "",
    address_city: "",
    address: "",
    pincode: "",
    company_logo: "",
    about_company: "",
    target_ports: "",
    logistic_company_services: "",
    mobile: "",
    phone: "",
  });

  const [company_logo, setCompanyLogo] = useState(null);

  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedAddressCountry, setSelectedAddressCountry] = useState(null);

  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedAddressCity, setSelectedAddressCity] = useState(null);

  const [countryList, setCountryList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [addressCityList, setAddressCityList] = useState([]);
  const [targetCountryList, setTargetCountryList] = useState([]);
  const [targetCountry, setTargetCountry] = useState();
  const [hsCodeList, setHsCodeList] = useState([]);
  const [hs_code_assign, setHsCodeAssign] = useState(null);
  const [hs_code, setHSCode] = useState([]);
  const [companySize, setCompanySize] = useState(null);
  const [yearOption, setYearOption] = useState([]);
  const [establishedYear, setEstablishedYear] = useState(null);
  const [planList, setPlanList] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [tradeMode, setTradeMode] = useState(null);
  const [industryList, setIndustryList] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState(null);
  const [services, setServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState(null);
  const [verrors, setVErrors] = useState({});
  const ALLOWED_TYPES = ["image/jpeg", "image/png", "image/jpg"];
  const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2 MB
  const [portsList, setPortsList] = useState([]);
  const [target_ports, setTagetPorts] = useState();
  const [parentServiceOptions, setParentServiceOptions] = useState([]);
  const [showParentService, setShowParentService] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const [phoneValue, setphoneValue] = useState();
  const [mobileValue, setmobileValue] = useState();

  let nav = useNavigate("");

  const invalidEmails = [
    "yopmail.com",
    "mailinator.com",
    "10minutemail.com",
    "guerrillamail.com",
    "trashmail.com",
    "temp-mail.org",
    "dispostable.com",
    "fakeinbox.com",
    "sharklasers.com",
    "getairmail.com",
    "maildrop.cc",
    "spambog.com",
    "mytemp.email",
    "throwawaymail.com",
    "tempmailaddress.com",
    "mailcatch.com",
    "moakt.com",
    "temp-mail.io",
    "tutanota.com",
  ];

  const yearsList = () => {
    let thisYear = new Date().getFullYear();
    let allYears = [];

    for (let x = thisYear; x >= 1901; x--) {
      const optionsYear = {
        value: x,
        label: x,
      };
      allYears.push(optionsYear);
    }
    setYearOption(allYears);
  };

  const getPlans = async (offset, limit, type, searchTxt = "") => {
    await props
      .getSubscriptionPlans(offset, limit, "created_at", "DESC", type, searchTxt)
      .then((response) => {
        if (response.status === true) {
          let pList = response.data.map((val) => {
            return {
              label: val.name,
              value: val.id,
            };
          });
          let dList = [
            {
              label: "Free",
              value: "",
            },
          ];
          let newPLList = [...dList, ...pList];
          setPlanList(newPLList);
        }
      })
      .catch((err) => {
        console.log("Error ==== ", err);
      });
  };

  const tradeModeOption = [
    // { label: "Select shipment mode", value: "" },
    { label: "Import", value: "Import" },
    { label: "Export", value: "Export" },
    { label: "Logistic Partner", value: "Logistic Partner" },
    { label: "Trader", value: "Trader" },
    { label: "Manufacturer", value: "Manufacturer" },
  ];

  const handleTradeModeChange = (event) => {
    searchPortList();
    setSelectedIndustry(null);
    setIndustryList([]);
    setServices([]);
    setSelectedServices(null);
    setSelectedValues([]);
    setTagetPorts([]);
    setTradeMode(event);
    if (event.value == 'Logistic Partner') {
      setShowParentService(true);
      fetchParentService();
    } else {
      setShowParentService(false);
    }
    setFormData((prevalue) => {
      return {
        ...prevalue,
        trade_mode: event.value,
        trade_mode_type: "BUYER",
        company_industry: "",
        company_services: "",
        logistic_company_services: "",
        target_ports: ""
      };
    });

    fetchIndustryByTradeMode(event.value);
    if (event.value == "Logistic Partner") {
      getPlans(0, 20, "LOG_PTR", "");
    } else {
      getPlans(0, 20, "buyerOrSupplier", "");
    }
  };

  const fetchIndustryByTradeMode = async (trade_mode) => {
    await axios
      .get(API_URL + `/trading-industries/${trade_mode}`)
      .then((response) => {
        if (response.status === 200) {
          let industryList = response.data.data;
          let iList = industryList.map((val) => {
            return {
              label: val.industy_name,
              value: val.id,
            };
          });
          setIndustryList(iList);
        }
      })
      .catch((err) => {
        console.log("Error === ", err);
      });
  };

  const handleTradeModeTypeChange = (e, trade_mode_type) => {
    const newInputFields = { ...formData };
    if (trade_mode_type === "BUYER") {
      newInputFields["trade_mode_type"] = "BUYER";
    } else if (trade_mode_type === "SUPPLIER") {
      newInputFields["trade_mode_type"] = "SUPPLIER";
    }
    setFormData(newInputFields);
  };

  const fetchCountries = async () => {
    await props
      .getCountries()
      .then((response) => {
        if (response.status === true) {
          const options = response.data.map((country) => ({
            value: country.id,
            label: country.name,
            countryCode: country.iso2,
          }));
          setCountryList(options);
        }
      })
      .catch((err) => {
        console.log("Error =", err);
        showErrorMessage("Something went wrong");
      });
  };

  const handleCountryChange = (cval) => {
    if (cval) {
      setSelectedCountry(cval);
      const countryId = cval.value;
      const countryName = cval.label;
      setFormData((prevalue) => {
        return {
          ...prevalue,
          country: countryName,
        };
      });

      fetchCityBasedOnCountry(countryId);
    }
  };

  const handleAddressCountryChange = (cval) => {
    if (cval) {
      setSelectedAddressCountry(cval);
      const countryId = cval.value;
      setFormData((prevalue) => {
        return {
          ...prevalue,
          address_country: cval.label,
        };
      });

      fetchAddressCityBasedOnCountry(countryId);

      //  if (isString(ctname)) {
      //    fetchCityBasedOnCountry(countryId, ctname, cid);
      //  } else {
      //    fetchCityBasedOnCountry(countryId, "", cid);
      //  }
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      // backgroundColor: 'lightblue', // Background color of the control
      // borderColor: state.isFocused ? 'blue' : 'gray', // Border color when focused/unfocused
      '&:hover': {
        // borderColor: 'green', // Border color on hover
      },
    }),

    // option: (provided, state) => ({
    //   ...provided,
    //   // backgroundColor: state.isSelected ? 'lightgreen' : 'white', // Background color when selected
    //   // color: state.isSelected ? 'black' : 'gray', // Text color when selected
    //   '&:hover': {
    //     backgroundColor: 'lightgray', // Hover color of options
    //   },
    // }),

    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#4c9bdb', // Background of the selected multi-value items
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#fff', // Color of the text inside the multi-value
      fontSize: "14px"
    }),

    multiValueRemove: (provided) => ({
      ...provided,
      color: '#df0024', // Remove button color
      ':hover': {
        backgroundColor: '#df0024', // Background color on hover for the remove button
      },
    }),
  };

  const fetchCityBasedOnCountry = async (countryId) => {
    await props
      .getCity(countryId)
      .then((response) => {
        if (response.status === true) {
          const options = response.data.map((ct) => ({
            value: ct.id,
            label: ct.name + (ct.state_code ? " (" + ct.state_code + ")" : ""),
            name: ct.name,
          }));
          setCityList(options);
        }
      })
      .catch((err) => {
        console.log("Error =", err);
        showErrorMessage("Something went wrong");
      });
  };

  const handleCityChange = (ctval) => {
    if (ctval != null) {
      setSelectedCity(ctval);
      setFormData((prevalue) => {
        return {
          ...prevalue,
          city: ctval.label,
          isNewVal: ctval.__isNew__ ? ctval.__isNew__ : false,
        };
      });
    }
  };

  const handleInputChange = (newValue) => {
    setCityList([]);
    if (!isEmpty(selectedCountry)) {
      if (newValue === "" || (newValue === null && selectedCountry.value > 0)) {
        setCityList([]);
        fetchCityBasedOnCountry(selectedCountry.value);
      }

      if (newValue !== "" && selectedCountry.value > 0) {
        if (newValue.length >= 3) {
          setCityList([]);
          axios
            .post(API_URL + "/cities/search", {
              search_txt: newValue,
              country_id: selectedCountry,
            })
            .then((response) => {
              if (response.status === 200) {
                if (response.data.status === true) {
                  const options = response.data.data.map((ct) => ({
                    value: ct.id,
                    label:
                      ct.name +
                      (ct.state_code ? " (" + ct.state_code + ")" : ""),
                    name: ct.name,
                  }));
                  setCityList(options);
                }
              }
            });
        }
      }
    }
  };

  const handleInputAddressCityChange = (newValue) => {
    setAddressCityList([]);
    if (!isEmpty(selectedAddressCountry)) {
      if (
        newValue === "" ||
        (newValue === null && selectedAddressCountry.value > 0)
      ) {
        setAddressCityList([]);
        fetchAddressCityBasedOnCountry(selectedAddressCountry.value);
      }
      if (newValue !== "" && selectedAddressCountry.value > 0) {
        if (newValue.length >= 3) {
          setAddressCityList([]);
          axios
            .post(API_URL + "/cities/search", {
              search_txt: newValue,
              country_id: selectedAddressCountry.value,
            })
            .then((response) => {
              if (response.status === 200) {
                if (response.data.status === true) {
                  const options = response.data.data.map((ct) => ({
                    value: ct.id,
                    label:
                      ct.name +
                      (ct.state_code ? " (" + ct.state_code + ")" : ""),
                    name: ct.name,
                  }));
                  setAddressCityList(options);
                }
              }
            });
        }
      }
    }
  };

  const validateCityInput = (inputValue) => {
    if (inputValue === "") return null;

    const validCityRegex = /^[a-zA-Z][a-zA-Z\d\s\(\)]*$/;
    let error = "";
    if (!validCityRegex.test(inputValue)) {
      error = errorMessages.IN_VALID_FIELD_FORMAT;
    }
    return error || null;
  };

  const fetchAddressCityBasedOnCountry = async (countryId) => {
    await props
      .getCity(countryId)
      .then((response) => {
        if (response.status === true) {
          const options = response.data.map((ct) => ({
            value: ct.id,
            label: ct.name + (ct.state_code ? " (" + ct.state_code + ")" : ""),
            name: ct.name,
          }));
          setAddressCityList(options);
        }
      })
      .catch((err) => {
        console.log("Error =", err);
        showErrorMessage("Something went wrong");
      });
  };

  const handleAddressCityChange = (ctval) => {
    if (ctval != null) {
      setSelectedAddressCity(ctval);
      const cityId = ctval.value;
      setFormData((prevalue) => {
        return {
          ...prevalue,
          address_city: ctval.label,
          isNewVal: ctval.__isNew__ ? ctval.__isNew__ : false,
        };
      });
    }
  };

  const fetchTargetCountry = async () => {
    await props
      .getCountries()
      .then((response) => {
        if (response.status === true) {
          const options = response.data.map((country) => ({
            value: country.id,
            label: country.name,
          }));
          setTargetCountryList(options);
        }
      })
      .catch((err) => {
        console.log("Error =", err);
        showErrorMessage("Something went wrong");
      });
  };

  const handleTargetCountryChange = (event) => {
    setTargetCountry(event);
    let target_country = map(event, "value");
    setFormData((prevalue) => {
      return {
        ...prevalue,
        target_country: target_country,
      };
    });
  };

  const fetchHsCode = async () => {
    await props
      .getHsCode()
      .then((response) => {
        if (response) {
          const options = response.map((hsCode) => ({
            value: hsCode.id,
            label: hsCode.code,
          }));
          setHsCodeList(options);
        }
      })
      .catch((err) => {
        console.log("Error =", err);
        showErrorMessage("Something went wrong");
      });
  };

  const handleHSCodeChange = (event) => {
    setHsCodeAssign(event);
    let res = event.filter((item) => item.value !== "");
    setHSCode(res);

    event = res;
    let isNewOption = event.some((item) => item.__isNew__ === true);

    let result = event.filter((item) => item.__isNew__ !== true);
    let hscodes = map(result, "label");

    let result1 = event.filter((item) => item.__isNew__ === true);
    let hscodesTxt = map(result1, "label");

    setFormData((prevalue) => {
      return {
        ...prevalue,
        hs_code: hscodes,
        isNewHsCodeOptionVal: isNewOption,
        hscodesTxt: hscodesTxt,
      };
    });
  };

  const handleHsCodeInputChange = (searchbox, x) => {
    if (searchbox !== "") {
      if (searchbox.length >= 3) {
        fetchHSCodeBasedOnSearch(searchbox);
      }
    }
  };

  const fetchHSCodeBasedOnSearch = async (searchbox = "") => {
    if (!isEmpty(searchbox)) {

      await props
        .getHSCodeSearch(searchbox)
        .then((response) => {
          if (response) {
            const options = response.map((hsCode) => ({
              value: hsCode.id,
              label: hsCode.code,
            }));
            const newHsCodeList = [...hsCodeList];

            options.forEach((option) => {
              if (
                !newHsCodeList.some(
                  (existing) => existing.value === option.value
                )
              ) {
                newHsCodeList.push(option);
              }
            });
            setHsCodeList(newHsCodeList);
          }
        })
        .catch((err) => {
          console.log("Error =", err);
          showErrorMessage("Something went wrong");
        });
    }
  };

  const companySizeList = [
    // { label: "Select company size", value: null },
    { label: "1-10 employees", value: "1-10" },
    { label: "11-50 employees", value: "11-50" },
    { label: "51-200 employees", value: "51-200" },
    { label: "201-500 employees", value: "201-500" },
    { label: "501-1000 employees", value: "501-1000" },
    { label: "1000-5000 employees", value: "1000-5000" },
    { label: "5001-10000 employees", value: "5001-10000" },
    { label: "10000+ employees", value: "10000+" },
  ];

  const handleSelectChangeCompanySize = (event) => {
    setCompanySize(event);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        company_size: event.value,
      };
    });
  };

  const handleSelectChangeEstablishedYear = (event) => {
    setEstablishedYear(event);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        established_year: event.value,
      };
    });
  };

  const handlePlanChange = (val) => {
    setSelectedPlan(val);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        plan: val.value,
      };
    });
  };

  const handlePlanInputChange = (val, actionMeta) => {
    const { prevInputValue } = actionMeta;
    if (!isEmpty(formData.trade_mode)) {
      if (size(val) > 3) {
        getPlans(0, 20, formData.trade_mode, val);
      } else if (size(val) === 0 && prevInputValue !== val) {
        getPlans(0, 20, formData.trade_mode, "");
      }
    }
  };

  const handleIndustryChange = (cval) => {
    const industryId = cval.value;
    setSelectedServices(null);
    setSelectedIndustry(cval);
    if (tradeMode && tradeMode.value != "Logistic Partner") {
      fetchServices(industryId);
    }
    setFormData((prevalue) => {
      return {
        ...prevalue,
        company_industry: cval.label,
      };
    });
  };

  const fetchServices = async (industry_id) => {
    setServices([]);
    await props
      .getServiceByIndustry(industry_id)
      .then((response) => {
        if (!isEmpty(response)) {
          const options = response.map((service) => ({
            value: service.id,
            label: service.service_name,
          }));

          setServices(options);
        }
      })
      .catch((err) => {
        console.log("Error fetching data:", err);
        showErrorMessage("Something went wrong");
      });
  };

  const handleServiceChange = (cval) => {
    // const serviceId = cval.value;
    setSelectedServices(cval);
    var serviceIdArray = [];

    cval.map((val) => {
      serviceIdArray.push(val.value);
    });
    setFormData((prevalue) => {
      return {
        ...prevalue,
        company_services: serviceIdArray,
      };
    });
  };

  const handleCompanyLogoChange = (e) => {
    const { name, files } = e.target;

    let error = { ...verrors };
    let erFlag = 0;
    if (files.length > 0) {
      const file = files[0];

      if (!ALLOWED_TYPES.includes(file.type)) {
        error.company_logo = "The file must be a file of type jpg, png, jpeg";
        erFlag = 1;
      } else if (file.size > MAX_FILE_SIZE) {
        error.company_logo = "The file must be less than or equal to 2 MB";
        erFlag = 1;
      } else {
        error.company_logo = "";
        erFlag = 0;
      }
    } else {
      error.company_logo = "";
      erFlag = 0;
    }

    setVErrors(error);

    if (erFlag == 0) {
      setFile(() => ({
        // ...prev,
        [`images`]: {
          path: URL.createObjectURL(files[0]),
          file: files[0],
        },
      }));

      setCompanyLogo(files[0]);
    } else {
      setFile(() => ({
        // ...prev,
        [`images`]: {
          path: null,
          file: null,
        },
      }));

      setCompanyLogo(files[0]);
    }
  };

  const handleSocialMediaLinkChange = (e, idx) => {
    const { name, value } = e.target;
    const newInputFields = [...SocialMedia];
    newInputFields[idx][name] = value;
    newInputFields[idx].Link = value;
    setSocialMedia(newInputFields);
  };

  // *** added link && social media link ******

  const Addvideolink = (e) => {
    setErrors({});
    setvideosecion((prev) => [...prev, { video_link: "" }]);
  };

  // ******* delete link ****
  const Deletevideolink = (idx) => {
    setvideosecion((prev) => prev.filter((_, index) => index !== idx));
    // setisButtonDisabled(false);
  };

  const Deletevideolink1 = (idx) => {
    setErrors({});
    setvideosecion((prev) => {
      const updatedLinks = prev.filter((_, index) => index !== idx);
      if (updatedLinks.length === 0) {
        return [{ video_link: "" }];
      }
      return updatedLinks;
    });

    const updatedFormData = new FormData();
    const updatedVideoLinks = videosection
      .filter((_, index) => index !== idx)
      .map((field) => field.video_link);
    if (updatedVideoLinks.length === 0 || updatedVideoLinks[0] === "") {
      updatedFormData.append("video_links", []);
    }
  };

  const styleError = {
    display: "block",
  };

  const handleVideoLinkChange = (e, idx) => {
    const { name, value } = e.target;
    const newInputFields = [...videosection];
    newInputFields[idx][name] = value;
    setvideosecion(newInputFields);
  };

  const handleLinkFocusOut = (e, idx) => {
    const { name, value } = e.target;
    let errorMessage = "";

    if (name === "video_link") {
      if (value !== "") {
        const videoRegExp = regExp.videoLink;
        const isValid = videoRegExp.test(value);

        if (!isValid) {
          errorMessage = errorMessages.IN_VALID_FIELD_FORMAT;
        }
      }

      setVErrors((prevErrors) => ({
        ...prevErrors,
        [`video_link${idx}`]: errorMessage,
      }));
    }

    if (name === "social_media_link") {
      if (value !== "") {
        const videoRegExp = regExp.videoLink;
        const isValid = videoRegExp.test(value);

        if (!isValid) {
          errorMessage = errorMessages.IN_VALID_FIELD_FORMAT;
        }
      }

      setVErrors((prevErrors) => ({
        ...prevErrors,
        [`social_media_link${idx}`]: errorMessage,
      }));
    }
  };

  // social media account

  const AddSocialmedia = (e) => {
    setErrors({});
    setSocialMedia((prev) => [...prev, { Link: "", social_media_option: "" }]);
  };

  const DeleteSocialmedialink = (idx) => {
    let errorObj = { ...errors };
    if (errorObj[`social_media_option${idx}`] !== undefined) {
      delete errorObj[`social_media_option${idx}`];
      setErrors(errorObj);
    }

    setSocialMedia((prev) => prev.filter((_, index) => index !== idx));
  };

  const DeleteSocialmedialink1 = (idx) => {
    setErrors({});
    setSocialMedia((prev) => {
      const updatedLinks = prev.filter((_, index) => index !== idx);
      if (updatedLinks.length === 0) {
        return [{ Link: "", social_media_option: "" }];
      }
      return updatedLinks;
    });

    const updatedFormData = new FormData();
    const updatedVideoLinks = SocialMedia.filter(
      (_, index) => index !== idx
    ).map((field) => field.Link);
    if (updatedVideoLinks.length === 0 || updatedVideoLinks[0] === "") {
      updatedFormData.append("social_media_links", []);
    }
  };

  const handleSocialMediaChange = (e, idx) => {
    const selectedValue = e;
    const updatedSocialMedia = [...SocialMedia];
    updatedSocialMedia[idx].social_media_option = selectedValue;
    updatedSocialMedia[idx].icons = e.icon.props.className;
    setSocialMedia(updatedSocialMedia);

    setErrors((prevErrors) => ({
      ...prevErrors,
      [`social_media_option${idx}`]: "",
    }));
  };

  const handleChange = (e) => {
    setFormData((prevalue) => {
      return {
        ...prevalue,
        [e.target.name]: e.target.value,
      };
    });
  };

  const getPrefix = () => {
    if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
    if (user && isDemoUser) return roles.DEMO.prefix;
    if (user && isEndUser) return roles.END_USER.prefix;
    if (user && isViewer) return roles.VIEWER.prefix;
    return roles.SUPER_ADMIN.prefix;
  };
  const validation = async () => {
    let er = {};

    if (formData.email === "") {
      er.email = errorMessages.FIELD_REQUIRED;
    } else if (formData.email.length > EMAIL_FIELD_MAX_LENGTH) {
      er.email = errorMessages.MAX_LENGTH_150_EXCEEDED;
    } else {
      const currentEmail = formData.email.split("@")[1];
      const regExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const check = regExp.test(formData.email);
      if (check === false) {
        er.email = errorMessages.IN_VALID_FIELD_FORMAT;
      } else if (invalidEmails.includes(currentEmail)) {
        er.email = errorMessages.IN_VALID_FIELD_FORMAT;
      } else {
        er.email = "";
        try {
          const response = await axios.post(API_URL + "/email/validation", {
            search_txt: formData.email,
            type: 'ENROLLMENT',
          });

          if (response.data.status === true) {
            er.email = response.data.message;
          } else {
            er.email = "";
          }
        } catch (err) {
          console.log("Error ============= ", err);
        }
      }
    }

    if (phoneValue) {
      let numberWithoutCountryCode = phoneValue
        .replace(/^\+(\d{1,4})\s?/, "")
        .replace(/\s/g, "");
      if (numberWithoutCountryCode.length === 0) {
        er.phone = errorMessages.FIELD_REQUIRED;
      } else if (!isValidPhoneNumber(phoneValue)) {
        er.phone = errorMessages.CONTACT_NUMBER_VALIDATION_MSG;
      } else {
        er.phone = "";
      }
    }

    if (mobileValue) {
      let numberWithoutCountryCode = mobileValue
        .replace(/^\+(\d{1,4})\s?/, "")
        .replace(/\s/g, "");
      if (numberWithoutCountryCode.length === 0) {
        er.mobile = errorMessages.FIELD_REQUIRED;
      } else if (!isValidPhoneNumber(mobileValue)) {
        er.mobile = errorMessages.CONTACT_NUMBER_VALIDATION_MSG;
      } else {
        er.mobile = "";
      }
    }

    if (formData.company_name === "" || formData.company_name === null) {
      er.company_name = errorMessages.FIELD_REQUIRED;
    } else if (formData.company_name.length > 150) {
      er.company_name = errorMessages.MAX_LENGTH_150_EXCEEDED;
    } else {
      const regExpComapnyName = regExp.company_name;
      const check = regExpComapnyName.test(formData.company_name);
      if (check === false) {
        er.company_name = errorMessages.IN_VALID_FIELD_FORMAT;
      } else {
        er.company_name = "";
      }
    }

    if (formData.country === "" || formData.country === null) {
      er.country = errorMessages.FIELD_REQUIRED;
    } else {
      er.country = "";
    }

    if (formData.trade_mode === "" || formData.trade_mode === null) {
      er.trade_mode = errorMessages.FIELD_REQUIRED;
    } else if (!formData.trade_mode) {
      er.trade_mode = errorMessages.FIELD_REQUIRED;
    } else {
      er.trade_mode = "";
    }

    if (tradeMode && tradeMode.value != "Logistic Partner") {
      if (formData.hs_code === "" || formData.hs_code === null) {
        er.hs_code = errorMessages.FIELD_REQUIRED;
      } else {
        er.hs_code = "";
      }
    }
    if (
      formData.company_industry === "" ||
      formData.company_industry === null
    ) {
      er.company_industry = errorMessages.FIELD_REQUIRED;
    } else {
      er.company_industry = "";
    }
    if (tradeMode && tradeMode.value != "Logistic Partner") {
      if (
        formData.company_services === "" ||
        formData.company_services === null || isEmpty(formData.company_services)
      ) {
        er.company_services = errorMessages.FIELD_REQUIRED;
      } else {
        er.company_services = "";
      }
    } else {
      if (formData.logistic_company_services === "" ||
        formData.logistic_company_services === null
      ) {
        er.company_services = errorMessages.FIELD_REQUIRED;
      } else {
        er.company_services = "";
      }
    }

    if (formData.data_source === "" || formData.data_source === null) {
      er.data_source = errorMessages.FIELD_REQUIRED;
    } else {
      er.data_source = "";
    }

    if (tradeMode && tradeMode.value == "Logistic Partner") {
      if (formData.target_ports == "" || formData.target_ports == null) {
        er.target_ports = errorMessages.FIELD_REQUIRED;
      } else {
        er.target_ports = "";
      }
    } else {
      er.target_ports = "";
    }


    if (formData.website != "") {
      if (formData.website > 255) {
        er.website = errorMessages.MAX_LENGTH_255_EXCEEDED;
      } else {
        const regExp =
          /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/;
        const check = regExp.test(formData.website);
        if (check === false) {
          er.website = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          er.website = "";
        }
      }
    } else {
      er.website = "";
    }

    if (company_logo != null) {
      if (!ALLOWED_TYPES.includes(company_logo.type)) {
        er.company_logo = "The file must be a file of type jpg, png, jpeg";
      } else if (company_logo.size > MAX_FILE_SIZE) {
        er.company_logo = "The file must be less than or equal to 2 MB";
      } else {
        er.company_logo = "";
      }
    } else {
      er.company_logo = "";
    }

    if (size(videosection) > 1) {
      let videoRegExp1 = regExp.videoLink;
      videosection.map((val, idx) => {
        if (isEmpty(val.video_link) && size(videosection) > 1) {
          er[`video_link${idx}`] = errorMessages.FIELD_REQUIRED;
        }
        if (!isEmpty(val.video_link)) {
          const isValid = videoRegExp1.test(val.video_link);
          if (!isValid) {
            er[`video_link${idx}`] = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er[`video_link${idx}`] = "";
          }
        }
      });
    } else if (size(videosection) == 1) {
      let videoRegExp1 = regExp.videoLink;
      if (!isEmpty(videosection[0].video_link)) {
        const isValid = videoRegExp1.test(videosection[0].video_link);
        if (!isValid) {
          er[`video_link${0}`] = errorMessages.IN_VALID_FIELD_FORMAT;
        }
      } else {
        er[`video_link${0}`] = "";
      }
    }

    if (!isEmpty(SocialMedia)) {
      SocialMedia.map((val, idx) => {
        if (isEmpty(val.Link) && !isEmpty(val.social_media_option)) {
          er[`social_media_link${idx}`] = errorMessages.FIELD_REQUIRED;
        } else {
          er[`social_media_link${idx}`] = "";
        }
        if (isEmpty(val.social_media_option) && !isEmpty(val.Link)) {
          const videoRegExp = regExp.videoLink;
          const isValid = videoRegExp.test(val.Link);

          if (!isValid) {
            er[`social_media_link${idx}`] = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er[`social_media_link${idx}`] = "";
          }

          er[`social_media_option${idx}`] = errorMessages.FIELD_REQUIRED;
        } else {
          er[`social_media_option${idx}`] = "";
        }
        if (!isEmpty(val.social_media_option) && !isEmpty(val.Link)) {
          const videoRegExp = regExp.videoLink;
          const isValid = videoRegExp.test(val.Link);
          if (!isValid) {
            er[`social_media_link${idx}`] = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er[`social_media_link${idx}`] = "";
          }
        }

        if (
          isEmpty(val.Link) &&
          isEmpty(val.social_media_option) &&
          size(SocialMedia) > 1
        ) {
          er[`social_media_option${idx}`] = errorMessages.FIELD_REQUIRED;
          er[`social_media_link${idx}`] = errorMessages.FIELD_REQUIRED;
        }
      });
    }

    setVErrors(er);

    let o = Object.keys(er)
      .filter((k) => er[k] != "")
      .reduce((a, k) => ({ ...a, [k]: er[k] }), {});

    return Object.keys(o).length > 0;
  };

  const handleFocusOut = async (e) => {
    let er = { ...verrors };
    if (e.target.name === "company_name") {
      if (e.target.value === "") {
        er.company_name = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > 150) {
        er.company_name = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else {
        const regExpComapnyName = regExp.company_name;
        const check = regExpComapnyName.test(e.target.value);
        if (check === false) {
          er.company_name = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          er.company_name = "";
        }
      }
    }

    if (e.target.name === "website") {
      if (e.target.value !== "") {
        if (e.target.value.length > 255) {
          er.website = errorMessages.MAX_LENGTH_255_EXCEEDED;
        } else {
          const regExp =
            /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/;
          const check = regExp.test(e.target.value);
          if (check === false) {
            er.website = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er.website = "";
          }
        }
      } else {
        er.website = "";
      }
    }

    if (e.target.name === "first_name") {
      if (e.target.value !== "") {
        if (e.target.value.length > 40) {
          er.first_name = errorMessages.MAX_LENGTH_EXCEEDED;
        } else {
          const regExpName = regExp.name;
          const check = regExpName.test(e.target.value);
          if (check === false) {
            er.first_name = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er.first_name = "";
          }
        }
      } else {
        er.first_name = "";
      }
    }

    if (e.target.name === "last_name") {
      if (e.target.value !== "") {
        if (e.target.value.length > 40) {
          er.last_name = errorMessages.MAX_LENGTH_EXCEEDED;
        } else {
          const regExpName = regExp.name;
          const check = regExpName.test(e.target.value);
          if (check === false) {
            er.last_name = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er.last_name = "";
          }
        }
      } else {
        er.last_name = "";
      }
    }

    if (e.target.name === "email") {
      if (e.target.value === "") {
        er.email = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > EMAIL_FIELD_MAX_LENGTH) {
        er.email = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else {
        const currentEmail = e.target.value.split("@")[1];
        const regExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const check = regExp.test(e.target.value);
        if (check === false) {
          er.email = errorMessages.IN_VALID_FIELD_FORMAT;
        } else if (invalidEmails.includes(currentEmail)) {
          er.email = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          er.email = "";
          try {
            const response = await axios.post(API_URL + "/email/validation", {
              search_txt: e.target.value,
              type: 'ENROLLMENT',
            });
            if (response.data.status === true) {
              er.email = response.data.message;
            } else {
              er.email = "";
            }
          } catch (err) {
            console.log("Error ============= ", err);
          }
        }
      }
    }

    if (e.target.name === 'phone') {
      let phoneValue = e.target.value;
      let numberWithoutCountryCode = phoneValue.replace(/^\+(\d{1,4})\s?/, '');
      numberWithoutCountryCode = numberWithoutCountryCode.replace(/\s/g, '');
      if (phoneValue) {
        if (!phoneValue || !isValidPhoneNumber(phoneValue) && numberWithoutCountryCode.length > 0) {
          er.phone = errorMessages.MOBILE_NUMBER_VALIDATION_MSG;
        } else {
          er.phone = '';
          // try {
          //   const response = await axios.post(API_URL + "/phone/validation",
          //     {
          //       search_txt: phoneValue,
          //     });
          //   if (response.data.status === true) {

          //     er.phone = response.data.message;
          //   } else {

          //     er.phone = '';
          //   }

          // } catch (err) {
          //   console.log("Error ============= ", err);
          //   showErrorMessage("Something went wrong");
          // }

        }
      }

    }

    if (e.target.name === 'mobile') {
      let mobileValue = e.target.value;
      let numberWithoutCountryCode = mobileValue.replace(/^\+(\d{1,4})\s?/, '');
      numberWithoutCountryCode = numberWithoutCountryCode.replace(/\s/g, '');
      if (mobileValue) {
        if (!mobileValue || !isValidPhoneNumber(mobileValue) && numberWithoutCountryCode.length > 0) {
          er.mobile = errorMessages.MOBILE_NUMBER_VALIDATION_MSG;
        } else {
          er.mobile = '';
          // try {
          //   const response = await axios.post(API_URL + "/phone/validation",
          //     {
          //       search_txt: mobileValue,
          //     });
          //   if (response.data.status === true) {

          //     er.mobile = response.data.message;
          //   } else {

          //     er.mobile = '';
          //   }

          // } catch (err) {
          //   console.log("Error ============= ", err);
          //   showErrorMessage("Something went wrong");
          // }

        }
      }

    }


    if (e.target.name === "data_source") {
      if (e.target.value === "") {
        er.data_source = errorMessages.FIELD_REQUIRED;
      } else {
        er.data_source = "";
      }
    }
    setVErrors(er);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isValidForm = await validation();
    if (!isValidForm) {
      setisButtonDisabled(true);
      setVErrors({});
      setErrors({});
      props.showLoading();
      let resheaders = setAuthHeaders();
      let headers = resheaders.headers;
      headers["content-type"] = "multipart/form-data";
      try {
        await axiosInstance
          .post(
            API_URL + "/save-member-form",
            {
              formData,
              videosection,
              SocialMedia: JSON.stringify(SocialMedia),
              company_logo,
            },
            { headers }
          )
          .then((response) => {

            if (response.data.status == true) {
              if (response.data.message == "Member Created Successfully") {
                // showSuccessMessage(response.data.message);
                // setTimeout(() => nav(ROUTES.COMPANY_LIST), 1000);
                if (formData.trade_mode == "Logistic Partner") {
                  // nav(ROUTES.LOGISTIC_MEMBERS);
                  nav(`/${getPrefix()}${privateRoutePaths.MANAGE_LOGISTIC_MEMBERS.path}`);
                  setTimeout(() => showSuccessMessage(response.data.message), 1000);
                  setisButtonDisabled(false);
                } else {
                  // nav(ROUTES.COMPANY_LIST);
                  nav(`/${getPrefix()}${privateRoutePaths.MANAGE_MEMBERS.path}`);
                  setTimeout(() => showSuccessMessage(response.data.message), 1000);
                  setisButtonDisabled(false);
                }

              }
            }

            let er = {};
            const errorsObj = {};

            if (response.data.status == false) {
              if (response.data.error) {
                if (!isEmpty(response.data.error.hscodesTxt)) {
                  let er1 = response.data.error.hscodesTxt;
                  let combinedErrors = er1.join("\n");
                  er.hs_code_combined = combinedErrors;
                } else {
                  er.hs_code_combined = "";
                }

                if (!isEmpty(response.data.error.company_industry)) {
                  er.company_industry = response.data.error.company_industry;
                }

                if (!isEmpty(response.data.error.company_name)) {
                  er.company_name = response.data.error.company_name;
                }

                if (!isEmpty(response.data.error.website)) {
                  er.website = response.data.error.website;
                }

                if (!isEmpty(response.data.error.company_services)) {
                  er.company_services = response.data.error.company_services;
                }

                if (!isEmpty(response.data.error.logistic_company_services)) {
                  er.company_services = response.data.error.logistic_company_services;
                }

                if (!isEmpty(response.data.error.country)) {
                  er.country = response.data.error.country;
                }

                if (!isEmpty(response.data.error.data_source)) {
                  er.data_source = response.data.error.data_source;
                }

                if (!isEmpty(response.data.error.email)) {
                  er.email = response.data.error.email;
                }

                if (!isEmpty(response.data.error.hs_code)) {
                  er.hs_code = response.data.error.hs_code;
                }

                if (!isEmpty(response.data.error.trade_mode)) {
                  er.trade_mode = response.data.error.trade_mode;
                }

                if (!isEmpty(response.data.error.target_ports)) {
                  er.target_ports = errorMessages.FIELD_REQUIRED;
                }

                const result = Object.entries(response.data.error);
                result.forEach(([key, value]) => {
                  if (key.startsWith("video_links")) {
                    const parts = key.split(".");
                    const index = parts[1]; // 0 , 1
                    errorsObj[`video_link${index}`] =
                      errorMessages.IN_VALID_FIELD_FORMAT;
                  }

                  if (key.startsWith("social_media_links")) {
                    const parts = key.split(".");
                    const index = parts[1]; // 0 , 1
                    errorsObj[`social_media_link${index}`] =
                      errorMessages.IN_VALID_FIELD_FORMAT;
                  }
                });
                if (!isEmpty(errorsObj)) {
                  setErrors(errorsObj);
                } else {
                  setErrors({});
                }
              }
            }
            setisButtonDisabled(false);
            setVErrors(er);
          });
      } catch (err) {
        // props.hideLoading();
        console.log("Error - ", err);
        setisButtonDisabled(false);
        showErrorMessage("Something Went Wrong!");
      }
      props.hideLoading();
    }
  };

  const isHSCodeDuplicate = (inputValue) => {
    return hsCodeList.some((option) => {
      let tmpLabel = option.label;
      let tmpLabels = tmpLabel.split("(");
      tmpLabel = trim(tmpLabels[0]);
      return tmpLabel.toLowerCase() === inputValue.toLowerCase();
    });
  };

  const isServiceDuplicate = (inputValue) => {
    return services.some((option) => {
      let tmpLabel = option.label;
      let tmpLabels = tmpLabel.split("(");
      tmpLabel = trim(tmpLabels[0]);
      return tmpLabel.toLowerCase() === inputValue.toLowerCase();
    });
  };

  const searchPortList = async (searchTxt) => {
    await props
      .searchPortList(searchTxt)
      .then((response) => {
        let portsData = response.data.data;
        const options = portsData.map((p) => ({
          value: p.id,
          label: capitalize(p.name),
          code: p.port_code,
        }));

        const newPortList = [...portsList];
        options.forEach((option) => {
          if (
            !newPortList.some(
              (existing) => existing.value === option.value
            )
          ) {
            newPortList.push(option);
          }
        });
        setPortsList(newPortList);
      })
      .catch((err) => {
        console.log("Error ==== ", err);
        showErrorMessage("Something Went Wrong!!");
      });
  };

  const handlePortsInputChange = (inputVal) => {
    if (inputVal.length >= 1) {
      searchPortList(inputVal);
    }
    // else {
    //   searchPortList();
    // }
  }

  const handleTargetPortChange = (event) => {
    setTagetPorts(event);
    let target_ports = map(event, 'value');
    setFormData((prevalue) => {
      return {
        ...prevalue,
        target_ports: target_ports,
      };
    });
  }

  const customFilter = (option, searchTxt) => {
    if (!isEmpty(option.data.code)) {
      if (option.data.code.toLowerCase().includes(searchTxt.toLowerCase())) {
        return true;
      }
    }
    if (option.data.label.toLowerCase().includes(searchTxt.toLowerCase())) {
      return true;
    } else {
      return false;
    }
  }

  useEffect(() => {
    // getPlans(0, 20, "");
    yearsList();
    const fetchData = async () => {
      await fetchCountries();
      await fetchTargetCountry();
      await fetchHsCode();
      // await searchPortList();
    };
    fetchData();
  }, []);

  const CustomOption = ({ innerRef, innerProps, isSelected, label }) => {
    return (
      <div ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center' }}>
        <input type="checkbox" checked={isSelected} readOnly />
        <label style={{ marginLeft: '8px' }}>{label}</label>
      </div>
    );
  }

  const CustomOption2 = ({ innerRef, innerProps, isSelected, label }) => {
    return (
      <div ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center' }}>
        {label && <><input type="checkbox" checked={isSelected} readOnly />
          <label style={{ marginLeft: '8px' }}>{label}</label> </>
        }
      </div>
    );
  }

  const CustomOption3 = ({ innerRef, innerProps, isSelected, label }) => {
    return (
      <div ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center' }}>
        {label && <><input type="checkbox" checked={isSelected} readOnly />
          <label style={{ marginLeft: '8px' }}>{label}</label> </>
        }
      </div>
    );
  }

  const CustomOption4 = ({ innerRef, innerProps, isSelected, label }) => {
    return (
      <div ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center' }}>
        {label && <><input type="checkbox" checked={isSelected} readOnly />
          <label style={{ marginLeft: '8px' }}>{label}</label> </>
        }
      </div>
    );
  }

  const handlePhoneChange = (val) => {
    setphoneValue(val);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        phone: val
      }
    });
  }

  const handleMobileChange = (val) => {
    setmobileValue(val);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        mobile: val
      }
    });

  }

  const fetchParentService = async () => {
    await props.getParentService().then((response) => {
      let parentServices = response.data.data;
      const parentServicesArray = Object.entries(parentServices);
      const options1 = parentServicesArray.map(([parentLabel, children]) => {
        return {
          label: parentLabel,
          options: children.map((child) => ({
            value: child.id,
            label: child.service_name,
            parentLabel: parentLabel,
          })),
        };
      });

      setParentServiceOptions(options1);
    }).catch((err) => {
      console.log("Error fetching data:", err);
      showErrorMessage("Something went wrong");
    });

  }

  const handleParentServiceChange = (selectedOptions) => {
    setSelectedValues(selectedOptions);

    const parentServiceIdArray = selectedOptions.map((val) => ({
      parent: val.parentLabel,
      childId: val.value,
    }));

    setFormData((prevalue) => ({
      ...prevalue,
      logistic_company_services: parentServiceIdArray,
    }));
  };

  const handleParentCheckboxChange = (parentOption, checked) => {
    let updatedSelectedValues = selectedValues.filter(
      (item) =>
        !parentOption.options.some((option) => option.value === item.value)
    );

    if (checked) {
      updatedSelectedValues = [
        ...updatedSelectedValues,
        ...parentOption.options,
      ];
    }

    setSelectedValues(updatedSelectedValues);
    handleParentServiceChange(updatedSelectedValues);
  };

  const handleChildCheckboxChange = (childOption, checked) => {

    let updatedSelectedValues;
    if (checked) {
      updatedSelectedValues = [...selectedValues, childOption];
    } else {
      updatedSelectedValues = selectedValues.filter(
        (item) => item.value !== childOption.value
      );
    }
    setSelectedValues(updatedSelectedValues);
    handleParentServiceChange(updatedSelectedValues);
  };

  const customOption = ({ data, isSelected, onChange }) => (
    <div
      style={{ paddingLeft: "20px", paddingTop: "5px", paddingBottom: "5px" }}
    >
      <input
        type="checkbox"
        value={data.value}
        checked={isSelected}
        onChange={() => handleChildCheckboxChange(data, !isSelected)}
        style={{ marginRight: "8px" }}
      />
      {data.label}
    </div>
  );
  const customParentOption = ({ data, isSelected, onChange }) => (
    <div style={{ paddingTop: "5px", paddingBottom: "5px" }}>
      <input
        type="checkbox"
        value={data.value}
        checked={isSelected}
        onChange={() => handleParentCheckboxChange(data, !isSelected)}
        style={{ marginRight: "8px" }}
      />
      <strong>{data.label}</strong>
    </div>
  );

  return (
    <div className="data-table-main">
      <SubHeader
        layer1="Supplier Directory"
        layer2=""
        layer3="Enrollment Form"
        pageName="Enrollment Form"
        clickable={{
          layer1: `/${getPrefix()}${privateRoutePaths.MANAGE_MEMBERS.path}`,
          layer2: "",
          layer3: "",
        }}
      />

      <div className="bg-white shadow rounded p-4 mb-4">
        <form onSubmit={handleSubmit}>
          <div class=" pb-3 border-bottom">
            <h4 class="head-office-text  ">Company Information Details</h4>
          </div>

          <div className="row  pt-3 update-profile-wrapper">
            <div className="col-xxl-4 col-xl-6 py-2">
              <label className="profile-text">
                Company Name
                <span className="text-danger"> *</span>
              </label>

              <InputField
                placeholder={"Enter your company name"}
                className={"input-error-border"}
                name="company_name"
                autoComplete="off"
                value={formData.company_name}
                onChange={handleChange}
                onBlur={handleFocusOut}
              ></InputField>

              {verrors.company_name && (
                <span className="company-required" style={styleError}>
                  {verrors.company_name}
                </span>
              )}
            </div>

            <div className="col-xxl-4 col-xl-6 py-2">
              <label className="profile-text">First Name</label>

              <div className="d-flex">
                <span className="input-group-addon">
                  <select
                    name="salutation"
                    value={formData.salutation}
                    onChange={handleChange}
                  >
                    <option value="Mr">Mr</option>
                    <option value="Mrs">Mrs</option>
                    <option value="Miss">Miss</option>
                  </select>
                </span>

                <div className="w-100">
                  <InputField
                    placeholder={"Enter your first name"}
                    className={"input-error-border mr-input"}
                    name="first_name"
                    autoComplete="off"
                    value={formData.first_name}
                    onChange={handleChange}
                    onBlur={handleFocusOut}
                  ></InputField>
                </div>
              </div>
              {verrors.first_name && (
                <span className="company-required" style={styleError}>
                  {verrors.first_name}
                </span>
              )}
            </div>

            <div className="col-xxl-4 col-xl-6 py-2">
              <label className="profile-text">Last Name</label>

              <InputField
                placeholder={"Enter your last name"}
                className={"input-error-border"}
                name="last_name"
                autoComplete="off"
                value={formData.last_name}
                onChange={handleChange}
                onBlur={handleFocusOut}
              ></InputField>
              {verrors.last_name && (
                <span className="company-required" style={styleError}>
                  {verrors.last_name}
                </span>
              )}
            </div>

            <div className="col-xxl-4 col-xl-6 py-2">
              <label className="profile-text">
                Email Address
                <span className="text-danger"> *</span>
              </label>

              <InputField
                placeholder={" Enter your email"}
                className={"input-error-border"}
                name="email"
                autoComplete="off"
                value={formData.email}
                onChange={handleChange}
                onBlur={handleFocusOut}
              ></InputField>
              {verrors.email && (
                <span className="company-required" style={styleError}>
                  {verrors.email}
                </span>
              )}
            </div>

            <div className="col-xxl-4 col-xl-6 py-2">
              <label className="profile-text">
                Phone No
              </label>

              <PhoneInput id="contact-form-phone" name="phone"
                international
                limitMaxLength
                placeholder="Enter contact"
                value={phoneValue}
                onChange={handlePhoneChange}
                onBlur={handleFocusOut}
                autoComplete="off"
              />
              {verrors.phone && (
                <span className="company-required" style={styleError}>
                  {verrors.phone}
                </span>
              )}
            </div>

            <div className="col-xxl-4 col-xl-6 py-2">
              <label className="profile-text">
                Mobile No
              </label>

              <PhoneInput
                id="contact-form-mobile"
                name="mobile"
                international
                limitMaxLength
                placeholder="Enter mobile"
                value={mobileValue}
                onChange={handleMobileChange}
                onBlur={handleFocusOut}
                // disabled={props.disableProfile}
                autoComplete="off"
              // countryCallingCodeEditable={true}
              // onKeyDown={handleKeyDown}
              />
              {verrors.mobile && (
                <span className="company-required" style={styleError}>
                  {verrors.mobile}
                </span>
              )}
            </div>

            <div className="col-xxl-4 col-xl-6 py-2">
              <label className="profile-text">
                Country
                <span className="text-danger"> *</span>
              </label>

              <DropDown
                placeholder={"Select country"}
                options={countryList}
                value={selectedCountry}
                onChange={handleCountryChange}
                onBlur={handleFocusOut}
                name={"country"}
              />
              {verrors.country && (
                <span className="company-required" style={styleError}>
                  {verrors.country}
                </span>
              )}
            </div>

            <div className="col-xxl-4 col-xl-6 py-2">
              <label className="profile-text">City</label>
              <CreatableSelect
                placeholder="Enter city"
                classNamePrefix={"creatable_react_select"}
                options={cityList}
                value={selectedCity}
                onChange={handleCityChange}
                onInputChange={handleInputChange}
                noOptionsMessage={() => "No City Found"}
                formatCreateLabel={(inputValue) => {
                  const validationError = validateCityInput(inputValue);
                  if (
                    validationError ||
                    validateCityInput(inputValue) ||
                    isEmpty(inputValue)
                  ) {
                    return;
                  }
                  return `Create "${inputValue}"`;
                }}
                isValidNewOption={(inputValue) => {
                  const validationError = validateCityInput(inputValue);
                  return validationError === null;
                }}
              />
            </div>

            <div className="col-xxl-4 col-xl-6 py-2">
              <label className="profile-text">
                HS Code
                {tradeMode && tradeMode.value != "Logistic Partner" && <span className="text-danger"> *</span>}
              </label>

              <CreatableSelect
                classNamePrefix={"creatable_react_select"}
                isMulti
                options={hsCodeList}
                onInputChange={handleHsCodeInputChange}
                closeMenuOnSelect={false}
                className={"member-form"}
                hideSelectedOptions={true}
                removeSelected={false}
                isClearable
                id="hs_code_dropdown"
                name="hs_code"
                components={{
                  Option: CustomOption2,
                  ClearIndicator: () => null,
                }}
                value={!isEmpty(hs_code) ? hs_code : null}
                onChange={handleHSCodeChange}
                noOptionsMessage={() => "No Hs Code Found"}
                formatCreateLabel={(inputValue) =>
                  isHSCodeDuplicate(inputValue) || isEmpty(inputValue)
                    ? null
                    : `Create "${inputValue}"`
                }
                isValidNewOption={(inputValue) =>
                  !isHSCodeDuplicate(inputValue)
                }
              />
              {verrors.hs_code && (
                <span className="company-required" style={styleError}>
                  {verrors.hs_code}
                </span>
              )}
              {verrors.hs_code_combined && (
                <span className="company-required" style={styleError}>
                  {verrors.hs_code_combined.split("\n").map((line, index) => (
                    <React.Fragment key={index}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
                </span>
              )}
            </div>

            <div className="col-xxl-4 col-xl-6 py-2">
              <label className="profile-text">
                Trading Country
              </label>

              <ReactSelect
                isMulti
                options={targetCountryList}
                closeMenuOnSelect={false}
                hideSelectedOptions={true}
                components={{ Option: CustomOption }}
                labelledBy="Select"
                name="target_country"
                classNamePrefix={"react-select creatable_react_select"}
                className={"member-form"}
                value={targetCountry}
                onChange={handleTargetCountryChange}
              />
            </div>

            <div className="col-xxl-4 col-xl-6 py-2">
              <label className="profile-text">Website</label>
              <InputField
                name="website"
                placeholder={"Enter your website url"}
                className={"input-error-border"}
                autoComplete="off"
                value={formData.website}
                onChange={handleChange}
                onBlur={handleFocusOut}
              ></InputField>
              {verrors.website && (
                <span className="company-required" style={styleError}>
                  {verrors.website}
                </span>
              )}
            </div>

            <div className="col-xxl-4 col-xl-6 py-2">
              <label className="profile-text">Company Size</label>

              <DropDown
                placeholder={"Select ..."}
                className={"input-error-border"}
                options={companySizeList}
                value={companySize}
                onChange={handleSelectChangeCompanySize}
              ></DropDown>
            </div>

            <div className="col-xxl-4 col-xl-6 py-2">
              <label className="profile-text">Established Year</label>
              <DropDown
                placeholder={"Select year"}
                className={"input-error-border"}
                name="established_year"
                options={yearOption}
                value={establishedYear}
                onChange={handleSelectChangeEstablishedYear}
              ></DropDown>
            </div>

            <div className="col-xxl-4 col-xl-6 py-2">
              <label className="profile-text">Plan</label>
              <DropDown
                placeholder={"Select plan"}
                options={planList}
                value={selectedPlan}
                onChange={handlePlanChange}
                onInputChange={handlePlanInputChange}
              ></DropDown>
            </div>

            <div className="col-xxl-4 col-xl-6 py-2">
              <label className="profile-text">
                Trade Mode
                <span className="text-danger"> *</span>
              </label>

              <DropDown
                placeholder={"Select mode"}
                name="shipment_mode"
                options={tradeModeOption}
                onChange={handleTradeModeChange}
                value={tradeMode}
              ></DropDown>
              {verrors.trade_mode && (
                <span className="company-required" style={styleError}>
                  {verrors.trade_mode}
                </span>
              )}
            </div>

            <div className="col-xxl-4 col-xl-6 py-2">
              <label className="profile-text">
                {" "}
                Company Industry
                <span className="text-danger"> *</span>
              </label>

              <CreatableSelect
                placeholder={"Select industry"}
                name="industry"
                classNamePrefix={"creatable_react_select"}
                options={industryList}
                value={selectedIndustry}
                onChange={handleIndustryChange}
              />
              {verrors.company_industry && (
                <span className="company-required" style={styleError}>
                  {verrors.company_industry}
                </span>
              )}
            </div>

            <div className="col-xxl-4 col-xl-6 py-2">
              <label className="profile-text">
                Company Services
                <span className="text-danger"> *</span>
              </label>
              {!showParentService &&
                <CreatableSelect
                  classNamePrefix={"creatable_react_select"}
                  isMulti
                  options={services}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={true}
                  removeSelected={false}
                  className={"member-form"}
                  isClearable
                  id="hs_code_dropdown"
                  name="services"
                  components={{
                    Option: CustomOption3,
                    ClearIndicator: () => null,
                  }}
                  value={selectedServices}
                  onChange={handleServiceChange}
                  noOptionsMessage={() => "No Services Found"}
                  formatCreateLabel={(inputValue) =>
                    isServiceDuplicate(inputValue) || isEmpty(inputValue)
                      ? null
                      : `Create "${inputValue}"`
                  }
                  isValidNewOption={(inputValue) =>
                    !isServiceDuplicate(inputValue)
                  }
                />
              }
              {showParentService &&
                <Select
                  options={parentServiceOptions}
                  className="member-form"
                  classNamePrefix={"react-select creatable_react_select"}
                  value={selectedValues}
                  onChange={handleParentServiceChange}
                  isMulti
                  closeMenuOnSelect={false}
                  components={{
                    Option: customOption,
                    GroupHeading: customParentOption,
                  }}
                />
              }
              {verrors.company_services && (
                <span className="company-required" style={styleError}>
                  {verrors.company_services}
                </span>
              )}
            </div>

            {tradeMode &&
              includes(["Trader", "Manufacturer"], tradeMode.value) && (
                <div className="col-xxl-4 col-xl-6 py-2">
                  <label className="profile-text">
                    Trade Mode Type <span className="text-danger">*</span>
                  </label>
                  <div className="d-flex">
                    <div className="mt-2">
                      <RadioButtonField
                        name={"buyer"}
                        onChange={(e) => handleTradeModeTypeChange(e, "BUYER")}
                        checked={formData.trade_mode_type === "BUYER"}
                      ></RadioButtonField>
                      <label className="">Buyer</label>
                    </div>
                    <div className="mt-2">
                      <RadioButtonField
                        name={"supplier"}
                        onChange={(e) =>
                          handleTradeModeTypeChange(e, "SUPPLIER")
                        }
                        checked={formData.trade_mode_type === "SUPPLIER"}
                      ></RadioButtonField>
                      <label className="">Supplier</label>
                    </div>
                  </div>
                </div>
              )}

            <div className="col-xxl-4 col-xl-6 py-2">
              <label className="profile-text">
                Data Source<span className="text-danger"> *</span>
              </label>

              <InputField
                placeholder={"Enter Data Source"}
                className={"input-error-border"}
                name="data_source"
                autoComplete="off"
                value={formData.data_source}
                onChange={handleChange}
                onBlur={handleFocusOut}
              ></InputField>
              {verrors.data_source && (
                <span className="company-required" style={styleError}>
                  {verrors.data_source}
                </span>
              )}
            </div>

            {tradeMode && tradeMode.value == "Logistic Partner" &&
              <div className='col-xxl-4 col-xl-6 py-2'>

                <label className='profile-text'>Target Ports
                  <span className='text-danger'>{' '}*</span>
                </label>

                <ReactSelect
                  options={portsList}
                  isMulti
                  onInputChange={handlePortsInputChange}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={true}
                  className={"member-form"}
                  labelledBy="Select"
                  name="target_ports"
                  value={target_ports}
                  classNamePrefix={"react-select creatable_react_select"}
                  onChange={handleTargetPortChange}
                  components={{ Option: CustomOption4 }}
                  // styles={customStyles}
                  noOptionsMessage={() => "No Port Found"}
                  filterOption={customFilter}
                />

                {verrors.target_ports && <span className="company-required" style={styleError}>{verrors.target_ports}</span>}

              </div>
            }
          </div>

          <div class=" py-3 border-bottom">
            <h4 class="head-office-text  ">Office Address</h4>
          </div>

          <div className="row pt-3">
            <div className="col-xxl-6 col-xl-6 py-2">
              <label className="profile-text">
                Country
              </label>

              <DropDown
                placeholder={"Select country"}
                className={"input-error-border"}
                options={countryList}
                onChange={handleAddressCountryChange}
                value={selectedAddressCountry}
              />
            </div>

            <div className="col-xxl-6 col-xl-6 py-2">
              <label className="profile-text">City</label>
              <CreatableSelect
                placeholder="Enter city"
                classNamePrefix={"creatable_react_select"}
                options={addressCityList}
                value={selectedAddressCity}
                onChange={handleAddressCityChange}
                onInputChange={handleInputAddressCityChange}
                formatCreateLabel={(inputValue) => {
                  const validationError = validateCityInput(inputValue);
                  if (
                    validationError ||
                    validateCityInput(inputValue) ||
                    isEmpty(inputValue)
                  ) {
                    return;
                  }
                  return `Create "${inputValue}"`;
                }}
                isValidNewOption={(inputValue) => {
                  const validationError = validateCityInput(inputValue);
                  return validationError === null;
                }}
              />
            </div>

            <div className="col-xxl-6 col-xl-6 py-2">
              <label className="profile-text">Address</label>
              <InputField
                placeholder={"Enter your address "}
                className={"input-error-border"}
                autoComplete="off"
                name="address"
                onChange={handleChange}
                value={formData.address}
              ></InputField>
            </div>

            <div className="col-xxl-6 col-xl-6 py-2">
              <label className="profile-text">Pincode</label>
              <InputField
                placeholder={"Enter your Pincode"}
                className={"input-error-border"}
                type={"text"}
                autoComplete="off"
                value={formData.pincode}
                name="pincode"
                onChange={handleChange}
              ></InputField>
            </div>
          </div>

          <div class=" py-3 border-bottom">
            <h4 class="head-office-text  ">Other Details</h4>
          </div>

          <div className="row pt-3">
            <div className="col-xxl-4 col-xl-6 py-2">
              <div className="d-flex justify-content-between">
                <div>
                  <label className="profile-text">Upload Company Logo</label>

                  <Choosefile
                    className={"form-control"}
                    type="file"
                    accept="image/jpeg, image/png, image/jpg"
                    onChange={handleCompanyLogoChange}
                  />

                  {verrors.company_logo && (
                    <span className="company-required" style={styleError}>
                      {verrors.company_logo}
                    </span>
                  )}

                  <p className="upload-info">
                    Allowed PDF, JPEG, JPG or PNG. Max size of 2 MB
                  </p>
                </div>

                <div className="upload-img position-static w-auto ms-2">
                  <img
                    src={file[`images`]?.path}
                    alt="IMAGE"
                    className="contactUploadImg"
                    id="pdf-img"
                  />

                  <p className="upload-info"></p>
                </div>
              </div>
            </div>

            <div className="col-xl-12 py-2">
              <label className="profile-text">About Company</label>

              <div>
                <div className="custom-ckeditor-container">
                  <CKEditor
                    editor={ClassicEditor}
                    data={formData.about_company || ""}
                    config={{
                      toolbar: {
                        items: [
                          "undo",
                          "redo",
                          "|",
                          "bold",
                          "italic",
                          "todoList",
                          "bulletedList",
                          "numberedList",
                          "fontSize",
                          "fontFamily",
                          "fontColor",
                          "fontBackgroundColor",
                          "alignment",
                          "link",
                        ],
                      },
                      plugins: [
                        Bold,
                        Essentials,
                        Italic,
                        Mention,
                        Paragraph,
                        Undo,
                        TodoList,
                        List,
                        Font,
                        Alignment,
                        Link,
                        AutoLink,
                      ],
                      licenseKey: "GPL",
                      mention: {},
                    }}
                    onReady={(editor) => {
                      editor.editing.view.change((writer) => {
                        writer.setStyle(
                          "height",
                          "150px",
                          editor.editing.view.document.getRoot()
                        );
                        writer.setStyle(
                          "width",
                          "100",
                          editor.editing.view.document.getRoot()
                        );
                      });
                    }}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setFormData((prev) => ({
                        ...prev,
                        about_company: data,
                      }));
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="col-xl-12 py-2">
              <div className="d-flex justify-content-between align-items-center border-bottom">
                <h4 className="head-office-text py-3">Company Videos</h4>

                <ButtonAdd onClick={Addvideolink}>
                  <i className="fa-solid fa-circle-plus mx-1"></i>
                  Add
                </ButtonAdd>
              </div>

              <div className="col-xxl-12 my-2">
                <div className="row">
                  {videosection &&
                    videosection.map((val, idx) => (
                      <div
                        className="col-xxl-4 col-xl-6 my-2"
                        key={`v1_${idx}`}
                        id={idx}
                      >
                        <label
                          className="my-2 other-info-title"
                          key={`v2_${idx}`}
                        >
                          {" "}
                          Video Link {idx + 1}
                        </label>
                        <div
                          className="d-flex align-items-center"
                          key={`v3_${idx}`}
                        >
                          <div className="w-100" key={`v4_${idx}`}>
                            <InputField
                              name="video_link"
                              placeholder={"Enter video link"}
                              className={"input-error-border"}
                              value={val.video_link}
                              onChange={(e) => handleVideoLinkChange(e, idx)}
                              onBlur={(e) => handleLinkFocusOut(e, idx)}
                              key={`v5_${idx}`}
                              autoComplete="off"
                            />
                          </div>

                          {size(videosection) > 1 && (
                            <i
                              className="fa-regular fa-trash-can text-danger mx-1 cursor-pointer fs-5 border border-danger p-1 rounded-circle"
                              onClick={() => Deletevideolink(idx)}
                              key={`v6_${idx}`}
                            ></i>
                          )}
                          {val.video_link !== "" &&
                            idx === 0 &&
                            size(videosection) === 1 && (
                              <i
                                className="fa-regular fa-trash-can text-danger mx-1 cursor-pointer fs-5 border border-danger p-1 rounded-circle"
                                onClick={() => {
                                  Deletevideolink1(idx);
                                }}
                                key={`v7_${idx}`}
                              ></i>
                            )}
                        </div>
                        {verrors[`video_link${idx}`] && (
                          <span
                            className="company-required-content"
                            style={styleError}
                            key={`v8_${idx}`}
                          >
                            {verrors[`video_link${idx}`]}
                          </span>
                        )}

                        {errors[`video_link${idx}`] && (
                          <span
                            className="company-required-content"
                            style={styleError}
                            key={`v8_${idx}`}
                          >
                            {errors[`video_link${idx}`]}
                          </span>
                        )}
                      </div>
                    ))}
                </div>
              </div>

              <div className="col-xl-12 py-2">
                <div className="d-flex justify-content-between align-items-center border-bottom">
                  <h4 className="head-office-text py-3">
                    Social Media Accounts
                  </h4>

                  <ButtonAdd onClick={AddSocialmedia}>
                    <i className="fa-solid fa-circle-plus mx-1"></i>
                    Add
                  </ButtonAdd>
                </div>

                {SocialMedia &&
                  SocialMedia.map((val, indx) => (
                    <div className="row mt-2 " key={`s1_${indx}`} id={indx}>
                      <div className="col-xxl-4 my-2 " key={`s2_${indx}`}>
                        <label
                          className="my-1 other-info-title"
                          key={`s3_${indx}`}
                        >
                          {" "}
                          Select Social Media
                        </label>
                        <div
                          className="d-flex align-items-center"
                          key={`s4_${indx}`}
                        >
                          <div className="w-100" key={`s5_${indx}`}>
                            <DropDown
                              options={SOCIAL_MEDIA_OPTIONS}
                              name={"social_media_option"}
                              onChange={(e) => handleSocialMediaChange(e, indx)}
                              value={val.social_media_option}
                              getOptionLabel={(e) => (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {e.icon}
                                  <span style={{ marginLeft: 5 }}>
                                    {e.label}
                                  </span>
                                </div>
                              )}
                              key={`s6_${indx}`}
                            ></DropDown>
                          </div>
                        </div>
                        {errors[`social_media_option${indx}`] && (
                          <span
                            className="company-required-content"
                            style={styleError}
                            key={`s7_${indx}`}
                          >
                            {errors[`social_media_option${indx}`]}
                          </span>
                        )}
                        {verrors[`social_media_option${indx}`] && (
                          <span
                            className="company-required-content"
                            style={styleError}
                            key={`s7_${indx}`}
                          >
                            {verrors[`social_media_option${indx}`]}
                          </span>
                        )}
                      </div>

                      <div className="col-xxl-4 my-2 " key={`s8_${indx}`}>
                        <label
                          className="my-1 other-info-title"
                          key={`s9_${indx}`}
                        >
                          {" "}
                          Social Media Link
                        </label>
                        <div
                          className="d-flex align-items-center"
                          key={`s10_${indx}`}
                        >
                          <div className="w-100" key={`s11_${indx}`}>
                            <InputField
                              name="social_media_link"
                              placeholder={"Enter social media link"}
                              onChange={(e) =>
                                handleSocialMediaLinkChange(e, indx)
                              }
                              onBlur={(e) => handleLinkFocusOut(e, indx)}
                              value={val.Link}
                              key={`s12_${indx}`}
                              autoComplete="off"
                            />
                          </div>
                          {size(SocialMedia) > 1 && (
                            <i
                              className="fa-regular fa-trash-can text-danger mx-1 cursor-pointer fs-5 border border-danger p-1 rounded-circle"
                              onClick={() => {
                                DeleteSocialmedialink(indx);
                              }}
                              key={`s13_${indx}`}
                            ></i>
                          )}
                          {val.Link != "" ||
                            (val.social_media_option.value > 0 &&
                              indx === 0 &&
                              size(SocialMedia) === 1 && (
                                <i
                                  className="fa-regular fa-trash-can text-danger mx-1 cursor-pointer fs-5 border border-danger p-1 rounded-circle"
                                  onClick={() => {
                                    DeleteSocialmedialink1(indx);
                                  }}
                                  key={`s14_${indx}`}
                                ></i>
                              ))}

                          {val.Link != "" &&
                            indx === 0 &&
                            size(SocialMedia) === 1 && (
                              <i
                                className="fa-regular fa-trash-can text-danger mx-1 cursor-pointer fs-5 border border-danger p-1 rounded-circle"
                                onClick={() => {
                                  DeleteSocialmedialink1(indx);
                                }}
                                key={`s15_${indx}`}
                              ></i>
                            )}
                        </div>
                        {errors[`social_media_link${indx}`] && (
                          <span
                            className="company-required-content"
                            style={styleError}
                            key={`s16_${indx}`}
                          >
                            {errors[`social_media_link${indx}`]}
                          </span>
                        )}
                        {verrors[`social_media_link${indx}`] && (
                          <span
                            className="company-required-content"
                            style={styleError}
                            key={`s16_${indx}`}
                          >
                            {verrors[`social_media_link${indx}`]}
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            </div>

            <div className="col-xxl-12 text-end">
              <ButtonAdminpanel type={"sumbit"} disabled={isButtonDisabled}>Submit</ButtonAdminpanel>
            </div>
          </div>
        </form>
      </div>
      {/* <ToastContainer /> */}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};
const mapDispatchToProps = (dispatch) => {
  return {
    getCountries: () => dispatch(countryList()),
    getCity: (countryId) => dispatch(cityMemberList(countryId)),
    getCitySearch: (city_name, countryId) =>
      dispatch(citySearchMemberList(city_name, countryId)),
    getHsCode: () => dispatch(getHSCodeList()),
    getHSCodeSearch: (searctText) => dispatch(getHSCodeSearchList(searctText)),
    getSubscriptionPlans: (
      offset,
      limit,
      columnName,
      sortDirection,
      type,
      searchTxt
    ) =>
      dispatch(
        getSubscriptionPlanList(
          offset,
          limit,
          columnName,
          sortDirection,
          type,
          searchTxt
        )
      ),
    getServiceByIndustry: (industry_id) =>
      dispatch(getServiceByIndustry(industry_id)),
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),
    searchPortList: (searchTxt) => dispatch(searchPortList(searchTxt)),
    getParentService: () => dispatch(getParentServiceAction()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MemberDetailsForm);
